import React from 'react';
import { PropTypes } from 'prop-types';
import {
    ConnectionsStrings,
    TenantsSpacesStrings,
    ProductsStrings,
} from '@general/helpers/SavedSearchesQuestionStrings';

export const SavedSearchDescription = ({ values }) => {
    const titleCase = str => str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());

    const descriptionStrings = {
        tenants: () => {
            const purposeString = values.tenants.purpose
                .map(purpose => TenantsSpacesStrings.purpose[purpose])
                .join(' ,');

            return `Finding "${purposeString}" Tenants, `;
        },
        space: () => {
            const purposeString = values.space.purpose.map(purpose => TenantsSpacesStrings.purpose[purpose]).join(', ');

            return `Finding "${purposeString}" Space, `;
        },
        connections: () =>
            `Finding "${ConnectionsStrings.connectionType[values.connections.connectionType]}" Connections, `,

        products: () => {
            const productTypesLength = values.products.productTypes.length;
            let titleText = values.products.areYou === 'LOOKING' ? 'Finding ' : 'Offering ';

            values.products.productTypes.forEach((productType, productTypeIndex) => {
                const productTypeText = ProductsStrings.productTypes[productType];

                titleText += productTypeText;
                if (productTypeIndex < productTypesLength - 1 && productTypesLength > 2) {
                    titleText += ', ';
                }

                if (productTypeIndex === productTypesLength - 2) {
                    if (productTypesLength === 2) {
                        titleText += ' ';
                    }

                    titleText += 'and ';
                }
            });

            return `${titleText}, `;
        },
    };

    const locationString = `${values.businessLocations.join(' / ')}`;

    const defaultTitle = titleCase(descriptionStrings[values.primaryInterest.toLowerCase()]() + locationString);

    return <>{defaultTitle}</>;
};

SavedSearchDescription.propTypes = {
    values: PropTypes.object.isRequired,
};
